module.exports = __webpack_public_path__ + "img/eye-dropper.1e632a04.svg";